"use client";

import { logger } from "@/utils/logger";
import { trackEvent } from "./track-event";

interface ShortlistTrackingProps {
	unitId?: string;
	projectId?: string;
	action: "add" | "remove";
	additionalOptions?: Record<string, unknown>;
}

/**
 * Track shortlist events with Google Ads conversion and analytics
 */
export function trackShortlist({ unitId, projectId, action, additionalOptions = {} }: ShortlistTrackingProps) {
	try {
		const isAdd = action === "add";
		const eventLabel = unitId ? "unit_shortlist" : "project_shortlist";

		// Track shortlist event
		trackEvent({
			google: {
				event: isAdd ? "add_to_shortlist" : "remove_from_shortlist",
				options: {
					event_category: "engagement",
					event_label: eventLabel,
					unit_id: unitId,
					project_id: projectId,
					action: action,
					...additionalOptions,
				},
			},
			matomo: {
				event: isAdd ? "add_to_shortlist" : "remove_from_shortlist",
				options: {
					category: eventLabel,
				},
			},
		});

		// Facebook AddToWishlist event for adding to shortlist
		if (isAdd) {
			trackEvent({
				facebook: {
					event: "AddToWishlist",
					options: {
						content_name: unitId ? "Unit Shortlist" : "Project Shortlist",
						content_category: "real_estate",
						content_ids: unitId ? [unitId] : projectId ? [projectId] : [],
						value: 1,
						currency: "INR",
					},
				},
			});
		}
	} catch (error) {
		// Catch any error to avoid breaking the main flow
		// eslint-disable-next-line no-console
		logger.debug("Error tracking shortlist :", error);
	}
}

/**
 * Track shortlist for specific unit
 */
export function trackShortlistUnit({
	unitId,
	action,
	additionalOptions,
}: {
	unitId: string;
	action: "add" | "remove";
	additionalOptions?: Record<string, unknown>;
}) {
	trackShortlist({
		unitId,
		action,
		additionalOptions,
	});
}

/**
 * Track shortlist for project
 */
export function trackShortlistProject({
	projectId,
	action,
	additionalOptions,
}: {
	projectId: string;
	action: "add" | "remove";
	additionalOptions?: Record<string, unknown>;
}) {
	trackShortlist({
		projectId,
		action,
		additionalOptions,
	});
}
